module.exports = __webpack_public_path__ + "static/media/1_en.aa73f791.png";